/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");

// Sentry — Vue 2 frontend error monitoring.
// SDK is a no-op when MIX_SENTRY_DSN is unset (local dev default).
import * as Sentry from "@sentry/vue";

global.jQuery = require("jquery");
require("select2");
var $ = global.jQuery;
window.$ = $;

window.Vue = require("vue");
window.Vue = window.Vue.default;

import store from "./store/index";

import dayjs from "dayjs";

Object.defineProperty(Vue.prototype, "$dayjs", { value: dayjs });

var utc = require("dayjs/plugin/utc");
dayjs.extend(utc);
var timezone = require("dayjs/plugin/timezone");
dayjs.extend(timezone);
var isSameOrAfter = require("dayjs/plugin/isSameOrAfter");
dayjs.extend(isSameOrAfter);

import VueTailwind from "vue-tailwind";

import VTsettings from "./VueTailwindSettings.js";
Vue.use(VueTailwind, VTsettings);

import { EventBus } from "./event-bus.js";
Object.defineProperty(Vue.prototype, "$EventBus", { value: EventBus });

import fabHelper from "./Helper.js";
import Vue from "vue";
Vue.prototype.$fabHelper = new fabHelper();

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

const files = require.context("./", true, /\.vue$/i);
files
    .keys()
    .map((key) =>
        Vue.component(key.split("/").pop().split(".")[0], files(key).default)
    );

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Sentry Vue 2 init — must run after Vue is set on window, before new Vue().
// No-op when MIX_SENTRY_DSN is not set.
if (process.env.MIX_SENTRY_DSN) {
    Sentry.init({
        Vue,
        dsn: process.env.MIX_SENTRY_DSN,
        environment: process.env.MIX_APP_ENV || "local",
        release: process.env.MIX_SENTRY_RELEASE,
        integrations: [Sentry.browserTracingIntegration()],
        tracesSampleRate: 0.1,
        sendDefaultPii: false,
    });
}

const app = new Vue({
    el: "#app",
    store,
    mounted() {},
});
